import styled from 'styled-components';
import { colors } from '../../../../healtheraComponents';

export const StyledCustomLinkContainer = styled.div`
  padding: 10px;
  margin-top: 10px;
  border-radius: 5px;
  background-color: ${colors.GRAY_LIGHTER};
  display: grid;
  gap: 10px;
  align-items: center;
  grid-template-columns: 24px auto auto 24px;
`;
